module.exports = __webpack_public_path__ + "img/2.0647ffd4.png";